module.exports = __webpack_public_path__ + "static/nolzurs_marvelous_pigments-e073a31fe64b55b063a9341eb7f248f1.jpeg";